import { movies } from "@/mocks/movies";
import { sortMovies } from "@/utils/movie";
import MovieCard from "@/components/feature/MovieCard";

export default function HotRecommend() {
  const hot = sortMovies(movies, "views").slice(0, 6);

  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
      {hot.map((movie, i) => (
        <MovieCard key={movie.id} movie={movie} rank={i + 1} />
      ))}
    </div>
  );
}